<template>
  <div class="help-block-item">
    <img
      class="help-block-item__icon"
      src="/local/templates/main/img/help-block/icon.png"
      alt=""
    >
    <h6 class="help-block-item__title">
      Опубликовать работу
    </h6>
    <p class="help-block-item__text">
      Расскажите нам, что вам нужно. Предоставьте как можно больше деталей, но не беспокойтесь о том, чтобы сделать его идеальным.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HelpBlockItem',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.help-block-item {
  &__icon{
    display: block;
    max-width: 50px;
    margin-bottom: 25px;
    @include mobile{
      margin-bottom: 15px;
    }
  }
  &__title{
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }
  &__text{
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }
}
</style>